var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogoProyecto(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 970.96 492.04",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Capa_2",
    "data-name": "Capa 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Capa_1-2",
    "data-name": "Capa 1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M409.35,468.84h-50L349.53,492H330.39l45-100h18.28l45.12,100H419.35Zm-6.13-14.56-18.85-43.7-18.71,43.7Zm-11.43-90h21l-24.84,19.56H372.52Z",
    style: {
      fill: "#232f3a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M563.28,492l-.14-66.25L530.3,480.55H522l-32.84-54V492h-17.7V392h15.28l39.69,66.25,39-66.25H580.7l.14,100Z",
    style: {
      fill: "#232f3a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M711.78,449.06q4.85,6.36,4.85,15.78,0,13-10,20.06T677.51,492H627.82V392h46.83q17.72,0,27.28,6.93T711.49,418a25,25,0,0,1-3.42,13.13,23.54,23.54,0,0,1-9.43,8.86A26.38,26.38,0,0,1,711.78,449.06Zm-65.4-42.48v27.56h26.27q9.72,0,14.92-3.5a11.51,11.51,0,0,0,5.22-10.21c0-4.57-1.74-8-5.22-10.35s-8.44-3.5-14.92-3.5ZM697.93,463q0-14.43-21.56-14.43h-30v28.85h30Q697.93,477.41,697.93,463Z",
    style: {
      fill: "#232f3a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M821.29,468.84h-50L761.47,492H742.33l45-100h18.28l45.12,100H831.29Zm-6.13-14.56-18.85-43.7-18.71,43.7Z",
    style: {
      fill: "#232f3a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M948.8,492,928.38,462.7a36.69,36.69,0,0,1-3.85.14H902V492H883.41V392h41.12q13,0,22.63,4.28a32.94,32.94,0,0,1,14.78,12.28q5.14,8,5.14,19,0,11.28-5.5,19.42a32.61,32.61,0,0,1-15.78,12.14l23,32.84Zm-6.71-79.1q-6.29-5.14-18.42-5.15H902v39.84h21.7q12.14,0,18.42-5.21t6.28-14.78Q948.37,418,942.09,412.87Z",
    style: {
      fill: "#232f3a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.91,199a26.46,26.46,0,0,1-10.3-9.88,27.5,27.5,0,0,1-3.73-14.23,27.19,27.19,0,0,1,3.77-14.22A26.63,26.63,0,0,1,88,150.83a30.34,30.34,0,0,1,14.72-3.58,30.71,30.71,0,0,1,12.08,2.31,24.63,24.63,0,0,1,9.22,6.69l-6.46,6.07a18.82,18.82,0,0,0-14.37-6.3,20.18,20.18,0,0,0-9.92,2.42,17.45,17.45,0,0,0-6.85,6.73,20.69,20.69,0,0,0,0,19.53,17.43,17.43,0,0,0,6.85,6.72,20.08,20.08,0,0,0,9.92,2.43,18.7,18.7,0,0,0,14.37-6.39l6.46,6.16a24.48,24.48,0,0,1-9.26,6.68,31,31,0,0,1-12.11,2.31A30.4,30.4,0,0,1,87.91,199Z",
    style: {
      fill: "#232f3a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215,189.39H188.13l-5.3,12.45h-10.3L196.74,148h9.85l24.29,53.82H220.43Zm-3.3-7.85L201.59,158l-10.07,23.52Z",
    style: {
      fill: "#232f3a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.05,200.84a25,25,0,0,1-9.19-4.69l3.46-7.76a27.25,27.25,0,0,0,8.11,4.26,29.28,29.28,0,0,0,9.65,1.66c4,0,7-.64,9-1.93a5.81,5.81,0,0,0,2.95-5.07,4.89,4.89,0,0,0-1.65-3.8,11.54,11.54,0,0,0-4.19-2.35q-2.53-.84-6.92-1.92a82,82,0,0,1-10-2.92,16.42,16.42,0,0,1-6.54-4.58q-2.73-3.11-2.73-8.42a14.41,14.41,0,0,1,2.42-8.11,16.4,16.4,0,0,1,7.31-5.8,29.48,29.48,0,0,1,11.95-2.16,38.65,38.65,0,0,1,9.69,1.23,26.76,26.76,0,0,1,8.23,3.54l-3.15,7.77a31,31,0,0,0-7.39-3.16,27.88,27.88,0,0,0-7.45-1.07c-3.95,0-6.89.66-8.81,2a6.16,6.16,0,0,0-2.88,5.3,4.8,4.8,0,0,0,1.65,3.77,11.93,11.93,0,0,0,4.19,2.3q2.53.85,6.92,1.93a72.18,72.18,0,0,1,9.84,2.88,16.85,16.85,0,0,1,6.58,4.58,12,12,0,0,1,2.73,8.3,14.15,14.15,0,0,1-2.43,8.07,16.48,16.48,0,0,1-7.34,5.77,30,30,0,0,1-12,2.15A41,41,0,0,1,290.05,200.84Z",
    style: {
      fill: "#232f3a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M416.25,189.39H389.34L384,201.84h-10.3L398,148h9.85l24.29,53.82H421.64Zm-3.3-7.85L402.8,158l-10.07,23.52Z",
    style: {
      fill: "#232f3a"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 3.54,
    y1: 0.21,
    x2: 3.54,
    y2: 492.04,
    style: {
      fill: "none",
      stroke: "#232f3a",
      strokeMiterlimit: 10,
      strokeWidth: "7.07995392017501px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 24.51,
    y1: 0.21,
    x2: 24.51,
    y2: 492.04,
    style: {
      fill: "none",
      stroke: "#232f3a",
      strokeMiterlimit: 10,
      strokeWidth: "7.07995392017501px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 45.48,
    y1: 0.21,
    x2: 45.48,
    y2: 492.04,
    style: {
      fill: "none",
      stroke: "#232f3a",
      strokeMiterlimit: 10,
      strokeWidth: "7.07995392017501px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 66.45,
    y1: 0.21,
    x2: 66.45,
    y2: 106.09,
    style: {
      fill: "none",
      stroke: "#232f3a",
      strokeMiterlimit: 10,
      strokeWidth: "7.07995392017501px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 87.51,
    y1: 296.02,
    x2: 87.51,
    y2: 492,
    style: {
      fill: "none",
      stroke: "#232f3a",
      strokeMiterlimit: 10,
      strokeWidth: "7.07995392017501px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 66.45,
    y1: 247.58,
    x2: 66.45,
    y2: 424.11,
    style: {
      fill: "none",
      stroke: "#232f3a",
      strokeMiterlimit: 10,
      strokeWidth: "7.07995392017501px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 108.51,
    y1: 247.58,
    x2: 108.51,
    y2: 416.06,
    style: {
      fill: "none",
      stroke: "#232f3a",
      strokeMiterlimit: 10,
      strokeWidth: "7.07995392017501px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 129.5,
    y1: 331.82,
    x2: 129.5,
    y2: 492,
    style: {
      fill: "none",
      stroke: "#232f3a",
      strokeMiterlimit: 10,
      strokeWidth: "7.07995392017501px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 150.49,
    y1: 247.58,
    x2: 150.49,
    y2: 355.95,
    style: {
      fill: "none",
      stroke: "#232f3a",
      strokeMiterlimit: 10,
      strokeWidth: "7.07995392017501px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 171.48,
    y1: 411.15,
    x2: 171.48,
    y2: 492,
    style: {
      fill: "none",
      stroke: "#232f3a",
      strokeMiterlimit: 10,
      strokeWidth: "7.07995392017501px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 192.48,
    y1: 247.58,
    x2: 192.48,
    y2: 380.61,
    style: {
      fill: "none",
      stroke: "#232f3a",
      strokeMiterlimit: 10,
      strokeWidth: "7.07995392017501px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 213.47,
    y1: 340.12,
    x2: 213.47,
    y2: 492,
    style: {
      fill: "none",
      stroke: "#232f3a",
      strokeMiterlimit: 10,
      strokeWidth: "7.07995392017501px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 234.46,
    y1: 247.58,
    x2: 234.46,
    y2: 416.06,
    style: {
      fill: "none",
      stroke: "#232f3a",
      strokeMiterlimit: 10,
      strokeWidth: "7.07995392017501px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 255.46,
    y1: 312.15,
    x2: 255.46,
    y2: 492,
    style: {
      fill: "none",
      stroke: "#232f3a",
      strokeMiterlimit: 10,
      strokeWidth: "7.07995392017501px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 276.45,
    y1: 247.58,
    x2: 276.45,
    y2: 370.99,
    style: {
      fill: "none",
      stroke: "#232f3a",
      strokeMiterlimit: 10,
      strokeWidth: "7.07995392017501px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 297.44,
    y1: 351.08,
    x2: 297.44,
    y2: 492,
    style: {
      fill: "none",
      stroke: "#232f3a",
      strokeMiterlimit: 10,
      strokeWidth: "7.07995392017501px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 318.44,
    y1: 247.58,
    x2: 318.44,
    y2: 441.67,
    style: {
      fill: "none",
      stroke: "#232f3a",
      strokeMiterlimit: 10,
      strokeWidth: "7.07995392017501px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 360.42,
    y1: 247.58,
    x2: 360.42,
    y2: 285.48,
    style: {
      fill: "none",
      stroke: "#232f3a",
      strokeMiterlimit: 10,
      strokeWidth: "7.07995392017501px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 339.07,
    y1: 321.52,
    x2: 339.07,
    y2: 386.02,
    style: {
      fill: "none",
      stroke: "#232f3a",
      strokeMiterlimit: 10,
      strokeWidth: "7.07995392017501px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 381.42,
    y1: 247.58,
    x2: 381.42,
    y2: 340.12,
    style: {
      fill: "none",
      stroke: "#232f3a",
      strokeMiterlimit: 10,
      strokeWidth: "7.07995392017501px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 402.41,
    y1: 268.94,
    x2: 402.41,
    y2: 340.12,
    style: {
      fill: "none",
      stroke: "#232f3a",
      strokeMiterlimit: 10,
      strokeWidth: "7.07995392017501px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 423.4,
    y1: 247.58,
    x2: 423.4,
    y2: 301.8,
    style: {
      fill: "none",
      stroke: "#232f3a",
      strokeMiterlimit: 10,
      strokeWidth: "7.07995392017501px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 444.4,
    y1: 281.54,
    x2: 444.4,
    y2: 352.5,
    style: {
      fill: "none",
      stroke: "#232f3a",
      strokeMiterlimit: 10,
      strokeWidth: "7.07995392017501px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 464.89,
    y1: 0.25,
    x2: 464.89,
    y2: 352.5,
    style: {
      fill: "none",
      stroke: "#232f3a",
      strokeMiterlimit: 10,
      strokeWidth: "7.07995392017501px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 485.95,
    y1: 0.25,
    x2: 485.94,
    y2: 60.7,
    style: {
      fill: "none",
      stroke: "#232f3a",
      strokeMiterlimit: 10,
      strokeWidth: "7.07995392017501px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 485.9,
    y1: 161.67,
    x2: 485.9,
    y2: 352.5,
    style: {
      fill: "none",
      stroke: "#232f3a",
      strokeMiterlimit: 10,
      strokeWidth: "7.07995392017501px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 506.84,
    y1: 243.92,
    x2: 506.84,
    y2: 352.5,
    style: {
      fill: "none",
      stroke: "#232f3a",
      strokeMiterlimit: 10,
      strokeWidth: "7.07995392017501px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 527.81,
    y1: 0.25,
    x2: 527.81,
    y2: 106.1,
    style: {
      fill: "none",
      stroke: "#232f3a",
      strokeMiterlimit: 10,
      strokeWidth: "7.07995392017501px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 548.78,
    y1: 171.63,
    x2: 548.78,
    y2: 352.5,
    style: {
      fill: "none",
      stroke: "#232f3a",
      strokeMiterlimit: 10,
      strokeWidth: "7.07995392017501px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 569.75,
    y1: 0.25,
    x2: 569.75,
    y2: 119.75,
    style: {
      fill: "none",
      stroke: "#232f3a",
      strokeMiterlimit: 10,
      strokeWidth: "7.07995392017501px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 590.72,
    y1: 0.25,
    x2: 590.72,
    y2: 352.5,
    style: {
      fill: "none",
      stroke: "#232f3a",
      strokeMiterlimit: 10,
      strokeWidth: "7.07995392017501px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 611.69,
    y1: 212.34,
    x2: 611.69,
    y2: 352.5,
    style: {
      fill: "none",
      stroke: "#232f3a",
      strokeMiterlimit: 10,
      strokeWidth: "7.07995392017501px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 632.66,
    y1: 0.25,
    x2: 632.66,
    y2: 352.5,
    style: {
      fill: "none",
      stroke: "#232f3a",
      strokeMiterlimit: 10,
      strokeWidth: "7.07995392017501px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 653.63,
    y1: 0.25,
    x2: 653.63,
    y2: 156.27,
    style: {
      fill: "none",
      stroke: "#232f3a",
      strokeMiterlimit: 10,
      strokeWidth: "7.07995392017501px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 674.6,
    y1: 72.34,
    x2: 674.6,
    y2: 352.5,
    style: {
      fill: "none",
      stroke: "#232f3a",
      strokeMiterlimit: 10,
      strokeWidth: "7.07995392017501px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 695.57,
    y1: 0.25,
    x2: 695.57,
    y2: 266.53,
    style: {
      fill: "none",
      stroke: "#232f3a",
      strokeMiterlimit: 10,
      strokeWidth: "7.07995392017501px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 716.54,
    y1: 144.79,
    x2: 716.54,
    y2: 352.5,
    style: {
      fill: "none",
      stroke: "#232f3a",
      strokeMiterlimit: 10,
      strokeWidth: "7.07995392017501px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 737.51,
    y1: 0.25,
    x2: 737.51,
    y2: 233.81,
    style: {
      fill: "none",
      stroke: "#232f3a",
      strokeMiterlimit: 10,
      strokeWidth: "7.07995392017501px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 87.42,
    y1: 72.34,
    x2: 87.42,
    y2: 106.1,
    style: {
      fill: "none",
      stroke: "#232f3a",
      strokeMiterlimit: 10,
      strokeWidth: "7.07995392017501px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 108.39,
    y1: 0.21,
    x2: 108.39,
    y2: 60.7,
    style: {
      fill: "none",
      stroke: "#232f3a",
      strokeMiterlimit: 10,
      strokeWidth: "7.07995392017501px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 129.36,
    y1: 51.41,
    x2: 129.36,
    y2: 106.1,
    style: {
      fill: "none",
      stroke: "#232f3a",
      strokeMiterlimit: 10,
      strokeWidth: "7.07995392017501px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 150.33,
    y1: 0.21,
    x2: 150.33,
    y2: 29.48,
    style: {
      fill: "none",
      stroke: "#232f3a",
      strokeMiterlimit: 10,
      strokeWidth: "7.07995392017501px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 171.3,
    y1: 0.21,
    x2: 171.3,
    y2: 60,
    style: {
      fill: "none",
      stroke: "#232f3a",
      strokeMiterlimit: 10,
      strokeWidth: "7.07995392017501px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 192.28,
    y1: 37.38,
    x2: 192.28,
    y2: 102.6,
    style: {
      fill: "none",
      stroke: "#232f3a",
      strokeMiterlimit: 10,
      strokeWidth: "7.07995392017501px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 213.25,
    y1: 0.21,
    x2: 213.25,
    y2: 37.38,
    style: {
      fill: "none",
      stroke: "#232f3a",
      strokeMiterlimit: 10,
      strokeWidth: "7.07995392017501px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 234.22,
    y1: 0.21,
    x2: 234.22,
    y2: 102.61,
    style: {
      fill: "none",
      stroke: "#232f3a",
      strokeMiterlimit: 10,
      strokeWidth: "7.07995392017501px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 255.19,
    y1: 60.7,
    x2: 255.19,
    y2: 102.61,
    style: {
      fill: "none",
      stroke: "#232f3a",
      strokeMiterlimit: 10,
      strokeWidth: "7.07995392017501px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 276.16,
    y1: 29.48,
    x2: 276.16,
    y2: 102.61,
    style: {
      fill: "none",
      stroke: "#232f3a",
      strokeMiterlimit: 10,
      strokeWidth: "7.07995392017501px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 297.13,
    y1: 0.21,
    x2: 297.13,
    y2: 42.83,
    style: {
      fill: "none",
      stroke: "#232f3a",
      strokeMiterlimit: 10,
      strokeWidth: "7.07995392017501px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 318.1,
    y1: 60.7,
    x2: 318.1,
    y2: 102.61,
    style: {
      fill: "none",
      stroke: "#232f3a",
      strokeMiterlimit: 10,
      strokeWidth: "7.07995392017501px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 339.07,
    y1: 0.21,
    x2: 339.07,
    y2: 81.65,
    style: {
      fill: "none",
      stroke: "#232f3a",
      strokeMiterlimit: 10,
      strokeWidth: "7.07995392017501px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 360.04,
    y1: 42.83,
    x2: 360.04,
    y2: 102.61,
    style: {
      fill: "none",
      stroke: "#232f3a",
      strokeMiterlimit: 10,
      strokeWidth: "7.07995392017501px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 381.01,
    y1: 0.21,
    x2: 381.01,
    y2: 25.53,
    style: {
      fill: "none",
      stroke: "#232f3a",
      strokeMiterlimit: 10,
      strokeWidth: "7.07995392017501px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 401.98,
    y1: 42.83,
    x2: 401.98,
    y2: 102.61,
    style: {
      fill: "none",
      stroke: "#232f3a",
      strokeMiterlimit: 10,
      strokeWidth: "7.07995392017501px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 422.95,
    y1: 0.21,
    x2: 422.95,
    y2: 66.04,
    style: {
      fill: "none",
      stroke: "#232f3a",
      strokeMiterlimit: 10,
      strokeWidth: "7.07995392017501px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 443.92,
    y1: 0.21,
    x2: 443.92,
    y2: 102.61,
    style: {
      fill: "none",
      stroke: "#232f3a",
      strokeMiterlimit: 10,
      strokeWidth: "7.07995392017501px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 758.48,
    y1: 60.7,
    x2: 758.48,
    y2: 352.5,
    style: {
      fill: "none",
      stroke: "#232f3a",
      strokeMiterlimit: 10,
      strokeWidth: "7.07995392017501px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 779.45,
    x2: 779.45,
    y2: 243.92,
    style: {
      fill: "none",
      stroke: "#232f3a",
      strokeMiterlimit: 10,
      strokeWidth: "7.07995392017501px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 800.42,
    y1: 29.48,
    x2: 800.42,
    y2: 352.5,
    style: {
      fill: "none",
      stroke: "#232f3a",
      strokeMiterlimit: 10,
      strokeWidth: "7.07995392017501px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 821.39,
    x2: 821.39,
    y2: 301.8,
    style: {
      fill: "none",
      stroke: "#232f3a",
      strokeMiterlimit: 10,
      strokeWidth: "7.07995392017501px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 842.36,
    y1: 60.7,
    x2: 842.36,
    y2: 352.5,
    style: {
      fill: "none",
      stroke: "#232f3a",
      strokeMiterlimit: 10,
      strokeWidth: "7.07995392017501px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 863.33,
    x2: 863.33,
    y2: 202.61,
    style: {
      fill: "none",
      stroke: "#232f3a",
      strokeMiterlimit: 10,
      strokeWidth: "7.07995392017501px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 884.31,
    y1: 119.75,
    x2: 884.31,
    y2: 352.5,
    style: {
      fill: "none",
      stroke: "#232f3a",
      strokeMiterlimit: 10,
      strokeWidth: "7.07995392017501px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 905.28,
    x2: 905.28,
    y2: 266.53,
    style: {
      fill: "none",
      stroke: "#232f3a",
      strokeMiterlimit: 10,
      strokeWidth: "7.07995392017501px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 926.25,
    x2: 926.25,
    y2: 352.5,
    style: {
      fill: "none",
      stroke: "#232f3a",
      strokeMiterlimit: 10,
      strokeWidth: "7.07995392017501px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 946.45,
    y1: 0.38,
    x2: 946.45,
    y2: 352.5,
    style: {
      fill: "none",
      stroke: "#232f3a",
      strokeMiterlimit: 10,
      strokeWidth: "7.07995392017501px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 967.42,
    y1: 0.38,
    x2: 967.42,
    y2: 352.5,
    style: {
      fill: "none",
      stroke: "#232f3a",
      strokeMiterlimit: 10,
      strokeWidth: "7.07995392017501px"
    }
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoProyecto);
export default __webpack_public_path__ + "static/media/logo-proyecto.5ceccedc5780c5190696aa2cf66e13ae.svg";
export { ForwardRef as ReactComponent };